import React, { Component } from 'react'
import { withStyles, Card, CardHeader, Avatar, Typography, CardContent, Grid, TextField, FormControl, InputLabel, Select, OutlinedInput, MenuItem, CardActions, Button } from '@material-ui/core';
import Add from '@material-ui/icons/Add'
import Rich from '../CO/Rich';
import { PostData, GetData } from '../../../api/service';
import Snack from '../../Snackbar/Snack';
import FileUpload from '../../AddNew/FileUpload';

const styles = theme => ({
  textField: {
    width: '100%'
  },
  formControl: {
    width: '100%',
    marginTop: theme.spacing.unit * 2
  }
})

class AddGalleryActivity extends Component {

  state = {
    dept_code: '',
    description: '',
    departments: [],
    image: [],
    isLoaded: true,
    open: false,
    message: ''
  }

  __getInitialState() {
    this.setState({
      dept_code: '',
      facility: ''
    })
  }



  componentDidMount() {
    GetData(`/getdepartments`)
      .then((resp) => {
        this.setState({
          departments: resp,
          isLoaded: true
        })
      })
  }

  componentDidUpdate(prevProps) {

  }



  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleRichChange = (name, data) => {

    this.setState({
      [name]: data
    })
  }

  onSetFile = (data) => {
    //console.log(data)
    this.setState({
      image: data
    })
  }

  onSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...this.state
    }

    //console.log(data);


    PostData(`/${this.props.apikey}/addgallery`, data)
      .then((resp) => {
        //console.log(resp)
        this.setState({
          open: true,
          message: resp
        })
      }).then(() => {
        this.__getInitialState();
        setTimeout(() => this.props.history.replace('/gallery/view'), 2000)
      })

  }

  render() {
    let { classes } = this.props;




    return (
      <div>

        {this.state.open ?
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: ''
              })
            }}
            message={this.state.message}
          />

          : null}
        <form onSubmit={this.onSubmit}>
          <Card>
            <CardHeader
              avatar={
                <Avatar>
                  <Add />
                </Avatar>
              }
              title={
                <Typography
                  variant="h6"
                >
                  Add New Gallery
                </Typography>
              }
            />
            <CardContent>
              <Grid container spacing={24}>
                <Grid item lg={12} sm={12}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel >
                      Department Code
                    </InputLabel>
                    <Select
                      value={this.state.dept_code}
                      onChange={this.handleChange}
                      input={
                        <OutlinedInput labelWidth={200} name="posted_as" />
                      }
                      required={true}
                      name="dept_code"

                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="COLLEGE">College Gallery</MenuItem>
                      {this.state.departments.map((el, index) =>
                        <MenuItem key={index} value={el.web_dept_code}>{el.dept_name}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item lg={12} sm={12}>
                  <Typography
                    variant="h6"
                  >
                    Description
                  </Typography>
                  <Rich
                    placeholder="Description"
                    onChange={this.handleRichChange.bind(this, 'description')}
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <FileUpload
                    dp={this.state.image}
                    apikey={this.props.apikey}
                    type={`DEPT_GALLERY`}
                    setDp={this.onSetFile.bind(this)}
                  />
                </Grid>



              </Grid>
            </CardContent>

            <CardActions>
              <Button
                variant="outlined"
                color="primary"
                type="submit"
              >
                Submit
            </Button>
            </CardActions>

          </Card>

        </form>

      </div>
    )
  }
}

export default withStyles(styles)(AddGalleryActivity)


// WEBPACK FOOTER //
// ./src/Components/Department/Gallery/AddGalleryActivity.js